import { render, staticRenderFns } from "./ConsultModal.vue?vue&type=template&id=0b530c20&scoped=true&"
import script from "./ConsultModal.vue?vue&type=script&lang=js&"
export * from "./ConsultModal.vue?vue&type=script&lang=js&"
import style0 from "./ConsultModal.vue?vue&type=style&index=0&id=0b530c20&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b530c20",
  null
  
)

export default component.exports